import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../api"
import { ICargo } from "../../../interfaces";

export const BusinessTodayRedirectPage = () => {
  const projectCode = 'NFT'
  const api = useApi(projectCode);
  const navigate = useNavigate()
  useEffect(() => {
    api.getRedirectLinkForBusinessToday((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        window.location.href = cargo.info;
      } else {
        switch(cargo.returnCode) {
          case '100003':
            window.location.href = `/web/login/${projectCode.toLocaleLowerCase()}?redirect_url=${window.location.href}`
            break;
          default:
        }
      }
    })
  }, [api, navigate])
  return (
    <></>
  )
}